function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import LogosTitleComponent from "segments/desktop/logos/components/logos-title/logos-title-component";
import Logos from "segments/desktop/core-components/logos/logos";
import colors from "styles/colors";
import { StyledTopLogosComponent } from "./top-logos-component.scss";
class TopLogosComponent extends PureComponent {
    render() {
        const { title, titleSize, logos, logosAdvancedProps } = this.props;
        const titleStyle = this.getTitleStyle();
        return /*#__PURE__*/ _jsxs(StyledTopLogosComponent, {
            className: "top-logos-component",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "logosTitleWrapper",
                    style: titleStyle,
                    children: /*#__PURE__*/ _jsx(LogosTitleComponent, {
                        title: title,
                        titleSize: titleSize
                    })
                }),
                /*#__PURE__*/ _jsx(Logos, _object_spread({}, logos, logosAdvancedProps))
            ]
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "getTitleStyle", ()=>{
            const { textAndLogosMargin, titleColor } = this.props;
            return _object_spread({}, titleColor && {
                color: colors[titleColor]
            }, textAndLogosMargin && {
                marginBottom: textAndLogosMargin
            });
        });
    }
}
export { TopLogosComponent as default };
TopLogosComponent.defaultProps = _object_spread_props(_object_spread({}, LogosTitleComponent.defaultProps), {
    logos: Logos.defaultProps,
    paddingTop: "68px",
    paddingBottom: "68px",
    mobilePaddingTop: "24px",
    mobilePaddingBottom: "24px",
    textAndLogosMargin: "24px"
});
